export default defineAppConfig({
  hiyieldNuxtLayerFirebase: {
    yourName: '',
    dbCollections: {},
    initStorage: {
      client: false,
      server: false
    },
    initAuth: {
      client: true,
      server: true
    },
    initFirestore: {
      client: true,
      server: true
    }
  }
})
